<template>
  <div
    class="info-block d-flex align-center px-3 py-1 mb-4"
    data-testid="executive-summary-archive-warning"
  >
    <v-icon size="24" icon="$warning" />
    <span
      class="body2 ml-2"
      v-html="$t('reports.executiveSummaryReport.archivedDataWarning')"
    ></span>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

// Shown while the selected range reaches back past the 90-day window (PLAT-4259). Sits outside
// #report-card, so it stays on screen and out of the exported PDF.
export default defineComponent({});
</script>
